import React from "react"
import { Grid } from "@material-ui/core"

import useStyles from "@/components/Container/styles"

const Divider: React.FC = (props) => {
	const { children } = props

	const classes = useStyles()

	return (
		<Grid
			container
			className={classes.container}
		>
			{children}
		</Grid>
	)
}

export default Divider
